import { Route, Routes } from 'react-router-dom';

import ClosureDetails from '../ClosureDetails';
import ClosureForm from '../ClosureForm';
import ClosureListing from '../ClosureListing';
import ClosureCandidateSubmission from '../components/ClosureCandidateSubmission';
import ContractRevenueCalculator from '../components/ContractRevenueCalculator';
import CustomizeClosureFields from '../components/CustomizeClosureField';
import PlacementOrigin from '../components/PlacementOrigin';
import { PlacementStageForm } from '../components/PlacementStageForm';
import PlacementStatus from '../components/PlacementStatus';
import CreateClosureOptions from '../CreateClosureOptions';

export const ClosureRoutes = () => (
  <Routes>
    <Route path="" element={<ClosureListing />} />
    <Route path="/add" element={<ClosureForm />} />
    <Route path="/createoptions" element={<CreateClosureOptions />} />
    <Route path="/covertsubmission" element={<ClosureCandidateSubmission />} />
    <Route path="/:id" element={<ClosureDetails />} />
    <Route path="/:closureId/:mode/:step" element={<ClosureForm />} />
    <Route path="/settings/placement_status" element={<PlacementStatus />} />
    <Route path="/settings/placement_origin" element={<PlacementOrigin />} />
    <Route path="/settings/placement_stage" element={<PlacementStageForm />} />
    <Route path="/app-settings/customize-placement-fields" element={<CustomizeClosureFields />} />
    <Route path="/settings/contract_revenue_calculator" element={<ContractRevenueCalculator />} />
  </Routes>
);
